import React, { useContext } from 'react'
import styled from 'styled-components'
import { FormatMessageType, Options } from '../../../common/types'
import {
  Column,
  FormSubGroup,
  FormSubGroupHeader,
  FormSubGroupHeading,
  FormSubGroupWrapper,
  Row,
  Section,
  SectionColumn,
} from '../../../components/layout'
import {
  DateInput,
  RadioButtonGroup,
  SelectInput,
  TextAreaInput,
  TextInput,
  TimeInput,
} from '../../../components/layout/form/input'
import { translateInputOptions } from '../../../util/translateInputOptions'
import { StateStore } from '../../StoreProvider'
import { serviceTypeOptions } from '../options'
import { SelectSectionColumn } from '../AddTowingOrder/TowingOrderDetailsSubFormContents'

interface FormContentsProps {
  formatMessage: FormatMessageType
  showTowingDateSpan: boolean
}

interface DateSectionColumnProps {
  reverse?: boolean
}

interface DividerProps {
  alignSelfEnd?: boolean
}

export const DateSectionColumn = styled(SectionColumn)<DateSectionColumnProps>`
  display: flex;
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
  justify-content: space-between;
  align-items: flex-end;
`

export const HalfDateInput = styled(DateInput)`
  width: calc(50% - 1rem);
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    width: calc(50% - 0.125rem);
  }
`

export const HalfTimeInput = styled(TimeInput)`
  width: calc(50% - 1rem);
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    width: calc(50% - 0.125rem);
  }
`

const HalfTextInput = styled(TextInput)`
  width: calc(50% - 1rem);
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    width: calc(50% - 0.125rem);
  }
`

export const Divider = styled.div<DividerProps>`
  display: flex;
  align-items: center;
  align-self: ${props => props.alignSelfEnd ? 'flex-end' : 'auto'};
  height: ${props => props.theme.inputFieldHeight};
  padding-top: 3px;

  &::after {
    content: '—';
  }
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    display: none;
  }
  
`

export const orderScheduleOptions: Options = {
  options: {
    single: 'towingOrder.scheduling_fixed',
    span: 'towingOrder.scheduling_flexible',
  },
}

export const TowingOrderDetailsSubFormContents: React.FunctionComponent<FormContentsProps> = ({
  formatMessage,
  showTowingDateSpan,
}) => {
  const translatedOrderScheduleOptions = translateInputOptions(orderScheduleOptions, formatMessage)
  const { state } = useContext(StateStore)

  if (!state.settings) {
    return null
  }

  return (
    <FormSubGroupWrapper>
      <FormSubGroupHeader>
        <Row>
          <Column>
            <FormSubGroupHeading>Työn tiedot</FormSubGroupHeading>
          </Column>
          <Column justify="flex-end">
            <RadioButtonGroup
              label={''}
              name="jobDetails.towingDateType"
              options={translatedOrderScheduleOptions}
            ></RadioButtonGroup>
          </Column>
        </Row>
      </FormSubGroupHeader>
      <FormSubGroup>
        {showTowingDateSpan ? (
          <Section columns={2}>
            <DateSectionColumn>
              <HalfDateInput label={'Pvm alkaen'} name="jobDetails.towingDate" required />
              <Divider />
              <HalfDateInput label={'Pvm viimeistään'} name="jobDetails.towingEndDate" />
            </DateSectionColumn>

            <DateSectionColumn>
              <HalfTimeInput label={'Alkaen klo'} name="jobDetails.towingTime" />
              <Divider />
              <HalfTimeInput label={'Viimeistään klo'} name="jobDetails.towingEndTime" />
            </DateSectionColumn>
          </Section>
        ) : (
          <Section columns={2} marginMobile="0">
            <DateSectionColumn>
              <HalfDateInput label={'Päivämäärä'} name="jobDetails.towingDate" required />
              <HalfTimeInput label={'Aika'} name="jobDetails.towingTime" />
            </DateSectionColumn>
            <SectionColumn />
          </Section>
        )}

        <Section columns={2}>
          <SelectSectionColumn>
            <SelectInput
              label="Hinauksen syy"
              name="jobDetails.towingReason"
              options={state.settings.towingReasons.map((label: string) => ({
                label,
                value: label,
              }))}
            />
            <SelectInput label="Alustava toimenpide" name="jobDetails.serviceType" options={serviceTypeOptions} />
          </SelectSectionColumn>
          <DateSectionColumn>
            <HalfTextInput label={'Tilauksen viite'} name="jobDetails.orderReference" />
            <HalfTextInput label="Vahinkotunnus" name="jobDetails.incidentCaseNo" />
          </DateSectionColumn>
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label={'Lisäselvitykset'} name="jobDetails.additionalInfo" />
          </SectionColumn>
          <SectionColumn>
            <TextAreaInput label={'Muistiinpanot'} name="jobDetails.notes" />
          </SectionColumn>
        </Section>
      </FormSubGroup>
    </FormSubGroupWrapper>
  )
}
